// extracted by mini-css-extract-plugin
export var container = "CardRankings-module--container--c1cb5";
export var content = "CardRankings-module--content--f6725";
export var controls = "CardRankings-module--controls--4d212";
export var plot = "CardRankings-module--plot--1b2f0";
export var stickyContainer = "CardRankings-module--stickyContainer--ddc12";
export var table = "CardRankings-module--table--59006";